import React from "react";
import { ChevronDown } from "lucide-react";

export default function ScrollCue() {
  const go = () => document.getElementById("testimonianze")?.scrollIntoView({ behavior: "smooth", block: "start" });
  return (
    <div className="flex justify-center px-4 pt-2 pb-4">
      <button
        type="button"
        onClick={go}
        data-testid="scroll-cue-testimonials"
        className="scroll-cue inline-flex items-center gap-2 rounded-full px-5 py-2 transition-colors duration-200 hover:border-white/40 hover:text-white"
        style={{ border: "1px solid rgba(255,255,255,0.18)", background: "transparent", color: "#B4B1BA", fontSize: "0.88rem", fontWeight: 600, fontFamily: "'Instrument Sans', sans-serif" }}
      >
        Scopri ora <ChevronDown size={16} className="scroll-cue-arrow" />
      </button>
    </div>
  );
}
